document.addEventListener('click', async (e) => {
   // Cerca il pulsante rimuovi tramite cart-remove-button
   if (e.target.closest('.cart-remove-button')) {
       setTimeout(async () => {
           const cart = await fetch('/cart.js').then(r => r.json());
           if (cart.item_count === 1 && cart.items[0].variant_id === 53635002597701) {
               await fetch('/cart/update.js', {
                   method: 'POST',
                   headers: {'Content-Type': 'application/json'},
                   body: JSON.stringify({updates: {53635002597701: 0}})
               });
               location.reload();
           }
       }, 500);
   }
});